import { sessaoFetch, sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function assinatura (parametro) {
  return sessaoFetch('base', `/usuario/assinatura`)
}
export async function get (id) {
  return sessaoFetchLoading(`consig`, `/usuarios/${id}`)
}
export async function getSemLoad (id) {
  return sessaoFetch(`consig`, `/usuarios/GetEnvelopado/${id}`)
}
export async function getUsuarios (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/ListarPaginadoRestringeUnidade?` + serialize(dados), 'GET')
}
export async function getUsuariosTodos (dados) {
  return sessaoFetchLoading('consig', '/usuarios/ListarTodos?' + serialize(dados))
}
export async function usuariosSelect (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/GetUsuariosSelect?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/PostEnvelopado`, 'POST', dados)
}
export async function addFila (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/PostEnvelopadoFila`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/PutEnvelopado`, 'PUT', dados)
}
export async function editFila (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/FilaPutEnvelopado`, 'PUT', dados)
}
export async function editPerfil (dados) {
  return sessaoFetchLoading(`base`, `/usuario/${dados.id}/perfil`, 'PUT', dados)
}
export async function editStatus (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/ativo`, 'PUT', dados)
}
export async function editStatusFila (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/filaativo`, 'PUT', dados)
}
export async function delUsuario (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/${dados}`, 'DELETE')
}
export async function delUsuarioFila (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/FilaDelete/${dados}`, 'DELETE')
}
export async function trocaSenha (dados) {
  return sessaoFetchLoading(`base`, `/usuario/senha`, 'PUT', dados)
}
export async function listComMetas () {
  return sessaoFetchLoading(`base`, `/usuario/list/meta`)
}
export async function listAtivos () {
  return sessaoFetchLoading(`base`, `/usuario/list/ativos`)
}
export async function trocaFoco (dados) {
  return sessaoFetchLoading(`consig`, `/Refresh/TrocaUnidadeFoco`, 'PUT', dados)
}
export async function enviaAcesso (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/`, 'PATCH', dados)
}
export async function numeroMaximoUsuariosPorUnidade () {
  return sessaoFetchLoading(`consig`, `/usuarios/NumeroMaximoUsuariosPorUnidade`, 'GET')
}
export async function validaNovoUsuario (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/ValidaNovoUsuario?${serialize(dados)}`, 'GET')
}
export async function validaSenhaComissao (dados) {
  return sessaoFetchLoading(`consig`, `/usuarios/ValidaSenhaComissao`, 'PATCH', dados)
}
export async function recuperaSenhaComissao (dados) {
  return sessaoFetchLoading('consig', '/usuarios/EsqueciSenhaComissao', 'POST', dados)
}
export async function alteraPromotora (dados) {
  return sessaoFetchLoading('base', '/usuario/AlterarPromotoraDaUnidadeUsuario', 'PUT', dados)
}



// WEBPACK FOOTER //
// ./src/api/usuario.js